import { styled } from "@linaria/react";
import { ReactNode, useEffect } from "react";
import { motion, useCycle, Variants } from "framer-motion";
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1jfytiq",
  vars: {
    "c1jfytiq-0": [({
      color
    }: {
      color: string;
    }) => color || "gold"]
  }
});
const BobContainer = /*#__PURE__*/styled(motion.div)({
  name: "BobContainer",
  class: "brl049b"
});
const Profile = /*#__PURE__*/styled("div")({
  name: "Profile",
  class: "pa3hvhp"
});
const ActivityIndicator = /*#__PURE__*/styled(motion.div)({
  name: "ActivityIndicator",
  class: "ax4wmut"
});
const Dot = /*#__PURE__*/styled(motion.div)({
  name: "Dot",
  class: "d1oeuny8"
});
const container = {
  idle: {
    opacity: 1,
    y: "0%"
  },
  typing: {
    transition: {
      staggerChildren: 0.25
    }
  }
};
const typingVariant: Variants = {
  idle: {
    opacity: 1,
    y: "0%",
    transition: {
      duration: 0.6
    }
  },
  typing: {
    y: ["0%", "-20%"],
    opacity: [1, 0.5],
    transition: {
      duration: 0.5,
      repeat: Infinity,
      repeatType: "reverse",
      ease: "easeOut"
    }
  }
};
const bobbingVariant: Variants = {
  idle: {
    y: "0%",
    transition: {
      duration: 2
    }
  },
  typing: {
    y: ["0%", "-9%"],
    transition: {
      duration: 1,
      repeat: Infinity,
      repeatType: "reverse",
      ease: "easeOut"
    }
  }
};

function BouncingDot() {
  return <Dot variants={typingVariant} />;
}

function UserPresence(props: {
  children: ReactNode;
  color: string;
}): JSX.Element {
  const {
    children,
    color = "#4797FF"
  } = props;
  const [state, cycleState] = useCycle("idle", "typing");
  useEffect(() => {
    const timer = setTimeout(() => cycleState(), 4000 + 12000 * Math.random());
    return () => clearTimeout(timer);
  }, [cycleState, state]);
  return <Container color={color}>
      <BobContainer variants={bobbingVariant} animate={state}>
        <Profile>{children}</Profile>
        <ActivityIndicator variants={container} animate={state}>
          <BouncingDot />
          <BouncingDot />
          <BouncingDot />
        </ActivityIndicator>
      </BobContainer>
    </Container>;
}

export default UserPresence;

require("../../../.linaria-cache/src/components/userPresence/index.linaria.module.css");